// Shared by the self-serve sign-up wizard and the admin tenant-creation
// wizard — "what do you call a warehouse?" (see Organization settings'
// Terminology section, where a tenant can also change this later).
export interface LocationLabelPreset {
  label: string;
  singular: string;
  plural: string;
}

export const LOCATION_LABEL_PRESETS: LocationLabelPreset[] = [
  { label: "Warehouse", singular: "Warehouse", plural: "Warehouses" },
  { label: "Store", singular: "Store", plural: "Stores" },
  { label: "Location", singular: "Location", plural: "Locations" },
  { label: "Branch", singular: "Branch", plural: "Branches" },
  { label: "Outlet", singular: "Outlet", plural: "Outlets" },
];

export const DEFAULT_LOCATION_LABEL_PRESET = LOCATION_LABEL_PRESETS[0];
